import { AgentType } from "@hightouch/lib/llm/shared";

import type { AGENTS_CHAT_AGENT_TYPE } from "src/components/llm/amp-agent/use-agents-chat-runtime";
import type { LlmChatSessionsBoolExp } from "src/graphql";

export const AGENT_SESSIONS_QUERY_KEY = "AgentSessions";

export const CHATS_PATH = "/agents/chats";

// Agent types that may have existing chat sessions (includes legacy types for backwards compatibility)
export const CHAT_SESSION_AGENT_TYPES = [
  AgentType.Routing,
  AgentType.Audience,
  AgentType.Journey,
  AgentType.Marketing,
  AgentType.Campaigns,
  AgentType.Copilot,
  AgentType.Idr,
] as const;

export type ChatSessionAgentType = AgentType | typeof AGENTS_CHAT_AGENT_TYPE;

/**
 * The single source of truth for "what counts as a user chat session". Both the
 * homepage feed and the /agents/chats sidebar build their query filter from here
 * so the definition can't drift between the two lists.
 *
 * Report-backed sessions are always created with `hidden: true`, so scoping to
 * `hidden: { _eq: false }` excludes them.
 */
export function buildChatSessionsFilter({
  userId,
  agentTypes = CHAT_SESSION_AGENT_TYPES,
  scopeToUser = true,
}: {
  userId: string | number | undefined;
  agentTypes?: readonly ChatSessionAgentType[];
  scopeToUser?: boolean;
}): LlmChatSessionsBoolExp {
  const agentTypeFilter = {
    _or: agentTypes.map((type) => ({ context: { _contains: { type } } })),
  };

  if (!scopeToUser) {
    return agentTypeFilter;
  }

  return {
    _and: [
      agentTypeFilter,
      { created_by: { _eq: String(userId) } },
      { hidden: { _eq: false } },
    ],
  };
}
